import React from 'react';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import HelpOutlineRounded from '@mui/icons-material/HelpOutlineRounded';

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip
    {...props}
    classes={{ popper: className }}
    slotProps={{
      popper: { disablePortal: false }
    }}
  />
))(({ theme }) => ({
  '& .MuiTooltip-tooltip': {
    backgroundColor: theme.palette.common.black,
    fontSize: 13
  },
  '& .MuiTooltip-arrow': {
    color: theme.palette.common.black
  }
}));

export default function InfoTooltip({ label, help, fontSize }) {
  return (
    <StyledTooltip title={label} placement="right" arrow>
      {help ? (
        <HelpOutlineRounded fontSize={fontSize || 'small'} />
      ) : (
        <InfoOutlinedIcon fontSize={fontSize || 'small'} />
      )}
    </StyledTooltip>
  );
}
